import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import "./Table.vue?vue&type=style&index=0&id=59aca886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59aca886"]])

export default __exports__